import React, {Component} from "react";
import ChangePassword from "./ChangePasswordView";
import {ChangePasswordService} from "../../service/login/ChangePasswordService";
import {isValidPassword} from "../../utils/validator/Session";

export default class ChangePasswordContainer extends Component {
    constructor(props) {
        super(props);

        this.changePasswordService = new ChangePasswordService();

        this.state = {
            isLoading: false,
            oldPassword: '',
            newPassword: '',
            confirmNewPassword: '',
        };

        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.handleSaveButton = this.handleSaveButton.bind(this);
        this.updateOldPassword = this.updateOldPassword.bind(this);
        this.updateNewPassword = this.updateNewPassword.bind(this);
        this.updateConfirmNewPassword = this.updateConfirmNewPassword.bind(this);
    }

    handleReturnButton() {
        this.props.history.push('/app/');
    }

    handleSaveButton() {
        if (this.state.newPassword !== this.state.confirmNewPassword) {
            alert("El nuevo password no coincide con la confirmación de Password.");
            this.setState({
                oldPassword: '',
                newPassword: '',
                confirmNewPassword: '',
            });
        } else if(this.state.newPassword.length >= 16 || this.state.confirmNewPassword.length >= 16){
            alert("El password debe tener una longitud menor a 16 caracteres.");
            this.setState({
                newPassword: '',
                confirmNewPassword: '',
            });
        } else if (this.state.oldPassword === this.state.newPassword){
            alert("El password nuevo debe ser diferente al anterior.");
            this.setState({
                newPassword: '',
                confirmNewPassword: '',
            });
        } else {
            if(isValidPassword(this.state.newPassword)){
                this.changePasswordService.changePassword(
                    ('username'),
                    this.state.oldPassword,
                    this.state.newPassword).then(
                    (data) => {
                        if (data.error === "") {
                            alert('Cambio exitoso');
                            localStorage.clear();
                            window.location.reload();
                        } else {
                            alert(data.error);
                            this.setState({
                                oldPassword: '',
                                newPassword: '',
                                confirmNewPassword: '',
                            });
                        }
                    });
            }else{
                alert('No cumple con la política');
            }
        }
    }

    updateOldPassword(event) {
        this.setState({oldPassword: event.target.value})
    }

    updateNewPassword(event) {
        this.setState({newPassword: event.target.value})
    }

    updateConfirmNewPassword(event) {
        this.setState({confirmNewPassword: event.target.value})
    }

    render() {
        return <ChangePassword
            updateOldPassword={this.updateOldPassword}
            updateNewPassword={this.updateNewPassword}
            updateConfirmNewPassword={this.updateConfirmNewPassword}
            handleReturnButton={this.handleReturnButton}
            handleSaveButton={this.handleSaveButton}
            oldPassword={this.state.oldPassword}
            newPassword={this.state.newPassword}
            confirmNewPassword={this.state.confirmNewPassword}

        />
    }
}